var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zui-screw zs-page--stretch zs-page"},[_vm._t("body")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }